import { connect } from 'react-redux';
import SetupHome from './SetupHome.jsx';
import {handlePartnerLoginClick, handleExitPartnerClick} from '../../shared/topBanner/actions';

const mapStateToProps = state => ({
  ...state.tournament.tournamentList,
  isAllowed: state.shared.auth.isAllowed,
  permissions: state.shared.auth.permissions,
  groupName: state.shared.auth.groupName
});

const mapDispatchToProps = dispatch => ({
    onPartnerLoginClick: () => dispatch(handlePartnerLoginClick()),
    onExitPartnerClick: () => dispatch(handleExitPartnerClick())
  });

export default connect(mapStateToProps, mapDispatchToProps)(SetupHome);



// WEBPACK FOOTER //
// ./src/features/tournament/home/SetupHomeContainer.jsx